module.exports = __webpack_public_path__ + "static/media/icon_194.a48e788a.svg";